module.exports = __webpack_public_path__ + "img/star.537671a7.svg";